import {ObvioEvent} from 'Event'
import {api} from 'lib/url'
import {useOrganization} from 'organization/OrganizationProvider'
import {useQuery} from 'react-query'
import {marketplaceApi} from 'lib/marketplace-api/url'
import {EventWithThankYouPage} from 'lib/marketplace-api/thank-you-page/use-thank-you-page-events'
import {ThankYouPage} from 'Event/Marketplace/thank-you-page'

export function useMarketplaceThankYouPageSampleEvents() {
  const {client} = useOrganization()

  return useQuery({
    queryKey: ['events', 'thank_you_page_samples'],
    queryFn: () =>
      new Promise<EventWithThankYouPage[]>(async (resolve) => {
        const events = await client.get<Array<ObvioEvent>>(
          api('/events/thank_you_page_samples'),
        )

        const thankYouPages = events.map(async (event) => {
          const thankYouPage = await client.get<ThankYouPage | null>(
            marketplaceApi(`/events/${event.id}/thank_you_page`),
          )

          if (!thankYouPage?.template) {
            return null
          }

          const hasSections = Boolean(thankYouPage.template.sections)
          if (!hasSections) {
            return null
          }

          return {
            ...event,
            thankYouPageTemplate: thankYouPage.template,
          }
        })

        const result = (await Promise.all(thankYouPages)).filter(
          (purchasePage) => purchasePage,
        ) as EventWithThankYouPage[]

        resolve(result)
      }),
  })
}
